module.exports = __webpack_public_path__ + "static/media/Banner_arquitetura_de_negocio.ea105e24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Arqnegicio_conceitos_apllic/Banner_arquitetura_de_negocio.png
// module id = 109
// module chunks = 0